<template>
  <DsProcessSection
    title=""
    title-id="firma-escrituras-process-title"
    intro="Tu camino está dividido en etapas claras. Aquí puedes entender qué sigue:"
    layout="grid"
    :columns="2"
    card-variant="stacked"
    :steps="steps"
  >
    <template #title>¿Cómo es el <span class="hl">proceso?</span></template>
    <template #step-1
      ><p>
        Nuestro equipo de asesores y expertos estarán encantados de brindarte toda la información necesaria y resolver
        tus dudas, haciendo el proceso más sencillo, agradable y seguro.
      </p></template
    >
    <template #step-2
      ><p>Es vital que <strong>todas las partes involucradas</strong> en la operación estén presentes en la notaría.</p>
      <p>
        Recuerda llevar tus <strong>documentos originales de identificación oficial</strong> (INE o pasaporte) y CURP,
        ambos válidos y actualizados. Tu ejecutivo asignado te ayudará a revisar detalladamente los lineamientos para
        una transacción ágil.
      </p></template
    >
    <template #step-3
      ><p>
        Una vez que la escritura haya sido firmada en la fecha programada, se realizará el pago al vendedor del inmueble
        y recibirás el comprobante correspondiente como evidencia de la operación. Con este paso, la compraventa quedará
        formalizada, brindándote la certeza jurídica necesaria para disfrutar plenamente de tu nuevo patrimonio.
      </p></template
    >
  </DsProcessSection>
</template>
<script setup lang="ts">
import DsProcessSection from '../components/DsProcessSection.vue'
const steps = [
  {
    id: '1',
    title: 'Acompañamiento y Asesoría'
  },
  {
    id: '2',
    title: 'Preparación y Asistencia a la Cita'
  },
  {
    id: '3',
    title: 'Pago a tu Vendedor',
    wide: true
  }
]
</script>
